import { ReportModel } from "models/ReportModel";

export type expandedFiltersType = {
  reportDate?: Date;
  updateDate?: Date;
  offenceIsSeriousCode?: number;
  offenceTypeCode?: number;
  rejectionReasonCode?: number;
  tags?: number;
  modelType?: string;
  licensePlateNumber?: string;
  carColor?: string;
  lableLocation?: string;
  seniorController?: string;
  regularController?: string;
  userAppName?: string;
  usersCharacteristic?: string;
};

export type filtersType = {
  reportsStatuses?: number[] | null;
  reportUpdateDatesRange?: { startDate: Date; endDate: Date } | null;
  decisionId?: number | null;
  policeDecision?: number | null;
  policeRejectionReason?: number | null;
};

export const initialFiltersValue: filtersType = {
  reportsStatuses: null,
  reportUpdateDatesRange: null,
  decisionId: null,
  policeDecision: null,
  policeRejectionReason: null,
};

export enum filterName {
  decisionId = "decisionId",
  policeDecision = "policeDecision",
  policeRejectionReason = "policeRejectionReason",
  reportsStatuses = "reportsStatuses",
}

export type reportsPageDataTypes = {
  pageCount: number;
  listItems: ReportModel[];
  totalPagedReports: number;
};
